export const ADD_CLIENT_HASH = "add-client";
export const ADD_CONSTRUCTION_HASH = "add-construction";
export const ADD_USER_HASH = "add-user";
export const SET_MESSAGE_HASH = "message";
